import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ListChecks } from 'lucide-react';
import { Button } from '@/ui';

interface FixListEntryCardProps {
  publicId: string;
}

// Entry CTA for the Fix List flow. Slots into the published report between
// the at-a-glance summary and the inspector's note. Visually heavier than
// the section list but lighter than the hero — the obvious "next step"
// without competing with anything above. Recipient is chosen on Step 3, so
// the copy here stays generic.
export const FixListEntryCard: React.FC<FixListEntryCardProps> = ({ publicId }) => (
  <section className="mt-6 grid grid-cols-[40px_1fr] sm:grid-cols-[40px_1fr_auto] gap-4 items-center rounded-xl border border-border-subtle bg-surface-1 shadow-card px-5 py-5 sm:px-6">
    <span
      className="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-brand-soft text-brand border border-brand/15"
      aria-hidden
    >
      <ListChecks className="h-5 w-5" strokeWidth={1.75} />
    </span>
    <div>
      <div className="text-overline uppercase text-brand">Next step</div>
      <h3 className="mt-1 font-display text-heading-lg text-ink leading-snug">
        Build a fix list to share
      </h3>
      <p className="mt-1 text-body-sm text-ink-subtle">
        Pick the items you want addressed, choose what should happen with each,
        and send the list to your inspector or the listing agent. Most people
        take about 5 minutes.
      </p>
    </div>
    <Link
      to={`/r/${publicId}/fix-list`}
      className="col-span-2 sm:col-span-1 sm:self-center"
    >
      <Button variant="primary" size="lg" block trailingIcon={<ArrowRight />}>
        Create fix list
      </Button>
    </Link>
  </section>
);
